
<script>
  import { Router, Route,Link,link } from "svelte-routing";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import MiRestaurante from "./../config/MiRestaurante.svelte";
  import Redirect from "./../config/RedirectToMenu.svelte";
  import Roles from "./../config/RolesConfig.svelte";

</script>
<Router >
    <main>
      <!-- You are here: <code>{path}</code> -->
      <Route path="/"><Redirect /></Route>
      <Route path="/menu" component={MiRestaurante}/>
      <Route path="/mi-service" component={MiRestaurante}/>
      <Route path="/roles" component={Roles}/>
      <Route path="/notification" component={MiRestaurante}/>
    </main>
  </Router>


